/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable default-case */
import { Component, OnInit, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { I18n, Amplify, Hub, Auth } from "aws-amplify";
import { AuthenticatorService, translations } from "@aws-amplify/ui-angular";
import {
    BaseUserService,
    SupportService,
    SupportModalComponent,
    Space,
} from "@smarterplan/ngx-smarterplan-core";
import { translate } from "@aws-amplify/ui";
import awsExports from "../../../../aws-exports";
// import { SupportService } from "src/app/services/support.service";
// import { SupportModalComponent } from "src/app/components/support-modal/support-modal.component";

I18n.putVocabularies(translations);
I18n.putVocabularies({
    fr: {
        "Your email address": "Votre adresse e-mail",
        "Your password": "Votre mot de passe",
        "Send Code": "Confirmer",
        Code: "Votre code de validation",
        Password: "Votre nouveau mot de passe",
        "Confirm Password": "Confirmez votre nouveau mot de passe",
        "User does not exist.": "Ce compte utilisateur n'existe pas.",
        "Incorrect username or password.":
            "Identifiant ou mot de passe incorrect.",
        "The user does not exist":
            "Cette adresse mail n'est affilié à aucun compte utilisateur",
        "Attempt limit exceeded, please try after some time.":
            "Limite de tentatives dépassée, veuillez réessayer après un certain temps.",
        "Your passwords must match": "Vos mots de passe doivent correspondre",
        "Invalid verification code provided, please try again.":
            "Code de vérification fourni non valide, veuillez réessayer.",
    },
    en: {
        "Your email address": "Your email address",
        "Your password": "Your password",
        "Send Code": "Confirm",
        Code: "Your validation code",
        Password: "Your new password",
        "Confirm Password": "Confirm your new password",
        "User does not exist.": "This user account does not exist.",
        "Incorrect username or password.": "Incorrect username or password.",
        "The user does not exist":
            "This email address is not affiliated with any user account",
        "Attempt limit exceeded, please try after some time.":
            "Attempt limit exceeded, please try after some time.",
        "Your passwords must match": "Your passwords must match",
        "Invalid verification code provided, please try again.":
            "Invalid verification code provided, please try again.",
    },
});

@Component({
    selector: "app-museum-auth",
    templateUrl: "./museum-auth.component.html",
    styleUrls: ["./museum-auth.component.scss"],
})
export class MuseumAuthComponent implements OnInit {
    user: any;

    space: Space;

    loading = false;

    chosenTemplateID: string;

    showAuthWaiting = false;

    formFields = {
        signIn: {
            username: {
                labelHidden: false,
                isRequired: true,
                label: translate("Your email address"),
                placeholder: translate("Enter your email"),
            },
            password: {
                labelHidden: false,
                isRequired: true,
                label: translate("Your password"),
                placeholder: translate("Enter your password"),
            },
        },
    };

    hubListener = (data) => {
        switch (data.payload.event) {
            case "signIn":
                this.loading = true;
                this.user = data.payload.data;
                this.handleRedirection();
                break;
            case "signUp":
                console.log("user signed up");
                break;
            case "signOut":
                console.log("user signed out");
                break;
            case "signIn_failure":
                console.log("user sign in failed");
                break;
            case "configured":
                console.log("the Auth module is configured");
                break;
            case "tokenRefresh":
                console.log("tokenRefresh", data);
                // console.log(this.authenticator.user);
                this.loading = true;
                this.onTokenRefresh();
                break;
            default:
                console.log(data.payload.event);
        }
    };

    constructor(
        public authenticator: AuthenticatorService,
        private router: Router,
        private ngZone: NgZone,
        private userService: BaseUserService,
        private supportService: SupportService,
    ) {
        Amplify.configure(awsExports);
    }

    async ngOnInit() {
        try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            this.loading = true;
            this.user = cognitoUser;
            this.handleRedirection();
        } catch (e) {
            console.log(e);
            this.authenticator.signOut();
            // console.log(this.authenticator.user);
        }
        Hub.listen("auth", this.hubListener);
    }

    ngOnDestroy() {
        // Hub.remove("auth", this.hubListener);
    }

    async handleRedirection() {
        if (!this.user) {
            return;
        }
        await this.userService.current(this.user);
        if (this.userService.cu) {
            const missions = this.userService.currentMissions;
            this.loading = false;
            if (missions) {
                if (this.userService.isMuseumVisitor()) {
                    if (missions.length > 1) {
                        // more than one visit mission => choose the one to attend
                        this.openWaitingRoomModal();
                    } else {
                        const { spaceID } = missions[0];
                        // redirect of museum users (guide and museum visitor)
                        const [missionVisitor] = missions;
                        if (missionVisitor.templateMissionID) {
                            if (!this.userService.cu.pseudo) {
                                this.chosenTemplateID =
                                    missionVisitor.templateMissionID;
                                this.openPseudoModal();
                            } else {
                                // the mission is linked to programmed visit (visite guidée)
                                // redirect to the waiting room
                                this.ngZone.run(() => {
                                    this.router.navigate([
                                        "waiting",
                                        missionVisitor.templateMissionID,
                                    ]);
                                });
                            }
                        } else {
                            // Redirect to the visit page ("visite libre")
                            this.ngZone.run(() => {
                                this.router.navigate(["museum", spaceID]);
                            });
                        }
                    }
                } else {
                    // any other user goes to dashboard
                    // console.log("redirect to dashboard");
                    this.ngZone.run(() => {
                        this.router.navigate(["dashboard"]);
                    });
                }
            }
        } else {
            this.loading = false;
        }
    }

    // eslint-disable-next-line class-methods-use-this
    openPseudoModal() {
        const pseudoContainer = document.querySelector(
            "app-museum-auth-pseudo",
        ) as HTMLElement;
        pseudoContainer.style.display = "flex";
    }

    openWaitingRoomModal() {
        this.showAuthWaiting = true;
        // const waitingContainer = document.querySelector(
        //     "app-museum-auth-waiting",
        // ) as HTMLElement;
        // waitingContainer.style.display = "flex";
    }

    setTemplateID(templateID: string) {
        this.showAuthWaiting = false;
        this.chosenTemplateID = templateID;
        const mission = this.userService.currentMissions.find(
            (m) => m.templateMissionID === templateID,
        );
        if (mission) {
            if (!this.userService.cu.pseudo) {
                this.openPseudoModal();
            } else {
                this.ngZone.run(() => {
                    this.router.navigate(["waiting", templateID]);
                });
            }
        }
    }

    async onTokenRefresh() {
        try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            console.log("user after tokenRefresh", cognitoUser);
            this.user = cognitoUser;
            this.handleRedirection();
        } catch (e) {
            console.log(e);
            this.user = null;
            this.loading = false;
        }
    }

    openSupportForm() {
        this.supportService.openSupportForm(SupportModalComponent);
    }
}
